import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const TransactionTabsStyle = {
  wrapper: css`
    .ant-tabs-content-holder {
      background-color: white;

      padding: 10px;
    }

    .ant-tabs-nav {
      &::before {
        display: none;
      }
      &-list {
        flex-wrap: wrap;
      }
    }

    .ant-tabs-tab {
      margin: unset !important;
      padding: 0 !important;
      color: ${theme.colors.white};

      &-active {
        span {
          color: ${theme.colors.orange[200]};
        }
      }

      &-btn {
        padding: 4px 8px;
        border: 1px solid #ccc;
        span {
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 16px;
        }
      }
    }

    .ant-tabs-ink-bar {
      display: none;
    }
  `,
};
